import apiUrls from './api-urls';

const customerId = process.env.VUE_APP_CUSTOMER_ID || 'demo';
const environmentName = process.env.VUE_APP_ENVIRONMENT_NAME || 'test';
const selectedTheme = process.env.VUE_APP_THEME_OVERRIDE || customerId;

if (typeof apiUrls[environmentName] === 'undefined') {
  throw new Error(`Environment ${environmentName} doesnt have defined API URL`);
}

const apiBaseUrl = apiUrls[environmentName];

export async function loadStyles() {
  // reason: alias in vite config
  // eslint-disable-next-line
  return import('@config/index.js');
}

export const config = {
  apiBaseUrl, customerId, selectedTheme,
};
